import {styled} from '@mui/styles';
import Switch from '@mui/material/Switch';
import {FormControlLabel} from '@mui/material';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

const IOSStyleSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({theme}) => ({
    width: 42,
    height: 26,
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        color: theme.palette.mode === 'light' ? '#fff' : '#acafb3',
        '&.Mui-checked': {
            color: '#2180f7',
            transform: 'translateX(15px)',
            '& + .MuiSwitch-track': {
                backgroundColor: theme.palette.mode === 'light' ? '#bdd9fd' : '#224064',
                opacity: 1,
                border: 0,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                backgroundColor: theme.palette.mode === 'light' ? '#d2d5d9' : '#626466',
                opacity: 0.5,
            },
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: theme.palette.mode === 'light' ? '#acafb3' : '#313233',
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            backgroundColor: theme.palette.mode === 'light' ? '#d2d5d9' : '#626466',
            opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 18,
        height: 18,
        marginTop: 2,
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        width: 35,
        height: 20,
        marginLeft: 1,
        backgroundColor: theme.palette.mode === 'light' ? '#d2d5d9' : '#505154',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
    },
}));

const useSwitchStyles = makeStyles((theme) => ({
    label: {
        fontFamily: 'Inter',
        fontWeight: 400,
        marginLeft: 3,
        display: 'flex',
        alignItems: 'center',
        '&.small': {
            fontSize: 12,
        },
        '&.medium': {
            fontSize: 14,
        },
        '&.large': {
            fontSize: 16,
        },
    },
    size: {
        '&.large': {
            width: 42,
            height: 24,
            '& .MuiSwitch-track': {
                width: 41,
                height: 24,
            },
            '& .MuiSwitch-thumb': {
                marginTop: -1,
                marginLeft: 1,
                width: 22,
                height: 22,
            },
        },
    },
}));

const AgyleSwitch = (props) => {
    const classes = useSwitchStyles();

    return (
        <FormControlLabel
            disabled={props.disabled}
            name={props.name}
            style={props.style}
            control={
                <IOSStyleSwitch
                    sx={{m: 1}}
                    checked={props.value}
                    onChange={props.onChange}
                    id={props.id}
                    className={clsx(classes.size, props.size)}
                />
            }
            label={
                <span className={clsx(classes.label, props.size)}>
                    {props.label}
                </span>
            }
            labelPlacement={props.labelPlacement}
        />
    );
};

export default AgyleSwitch;

AgyleSwitch.propTypes = {
    value: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string,
    disabled: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    labelPlacement: PropTypes.oneOf(['end', 'start', 'top', 'bottom'])
};

AgyleSwitch.defaultProps = {
    size: 'medium',
    value: false,
    disabled: false,
    label: '',
    labelPlacement: 'end'
};